(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-collection-carousel-track]');
      var prevButton = carousel.querySelector('[data-collection-carousel-prev]');
      var nextButton = carousel.querySelector('[data-collection-carousel-next]');

      if (!track || !prevButton || !nextButton) return;

      function updateButtons() {
        var maxScrollLeft = track.scrollWidth - track.clientWidth;
        prevButton.disabled = track.scrollLeft <= 1;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 1;
      }

      prevButton.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });

      track.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(updateButtons);
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons);

      updateButtons();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
